var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "d-flex align-items-end" },
        [
          _c(
            "b-form-group",
            {
              staticClass: "mb-0 mt-0",
              attrs: { "label-size": "sm", label: "Тип оплаты:" }
            },
            [
              _c("b-form-select", {
                attrs: { disabled: _vm.readonly, options: _vm.tp },
                model: {
                  value: _vm.order.typePayment,
                  callback: function($$v) {
                    _vm.$set(_vm.order, "typePayment", $$v)
                  },
                  expression: "order.typePayment"
                }
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.isComboPayment
            ? _c(
                "b-button",
                {
                  directives: [
                    {
                      name: "b-modal",
                      rawName: "v-b-modal.modal-add-payment",
                      modifiers: { "modal-add-payment": true }
                    }
                  ],
                  staticClass: "ml-1",
                  attrs: {
                    variant: _vm.errorValidator !== null ? "danger" : null
                  }
                },
                [
                  _c("icon", {
                    attrs: { name: !_vm.readonly ? "edit" : "eye" }
                  })
                ],
                1
              )
            : _vm._e()
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "b-modal",
        {
          ref: "modal-add-payment",
          attrs: {
            id: "modal-add-payment",
            centered: "",
            "ok-only": true,
            "ok-title": "Сохранить",
            title: "Типы оплаты:",
            "hide-footer": _vm.readonly
          },
          on: {
            show: _vm.showModal,
            hide: _vm.hideModal,
            ok: function($event) {
              return _vm.savePayment()
            }
          }
        },
        [
          _vm.errorValidator !== null
            ? _c("b-alert", { attrs: { show: "", variant: "danger" } }, [
                _vm._v(_vm._s(_vm.errorValidator.error))
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "mb-3 text-center" }, [
            _vm._v("Сумма заказа: "),
            _c("b", [_vm._v(_vm._s(_vm.orderSum))])
          ]),
          _vm._v(" "),
          _vm._l(_vm.selectedPayments, function(paymentItem, index) {
            return _c(
              "b-row",
              {
                key: paymentItem.type.keyword + index,
                staticClass: "mb-1 paymentRow"
              },
              [
                _c(
                  "b-col",
                  { attrs: { md: "9" } },
                  [
                    _c(
                      "b-row",
                      [
                        _c(
                          "b-col",
                          { attrs: { md: "8" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-0 mt-0",
                                attrs: {
                                  "label-size": "sm",
                                  label: "Тип оплаты:"
                                }
                              },
                              [
                                _c("b-form-select", {
                                  attrs: {
                                    options: _vm.typesPaymentFiltered,
                                    disabled:
                                      paymentItem.disabled || _vm.readonly
                                  },
                                  model: {
                                    value: paymentItem.type,
                                    callback: function($$v) {
                                      _vm.$set(paymentItem, "type", $$v)
                                    },
                                    expression: "paymentItem.type"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        ),
                        _vm._v(" "),
                        _c(
                          "b-col",
                          { attrs: { md: "4" } },
                          [
                            _c(
                              "b-form-group",
                              {
                                staticClass: "mb-0 mt-0",
                                attrs: { "label-size": "sm", label: "Сумма:" }
                              },
                              [
                                _c("b-form-input", {
                                  attrs: {
                                    type: "number",
                                    placeholder: "Введите сумму",
                                    disabled:
                                      paymentItem.disabled || _vm.readonly
                                  },
                                  on: {
                                    keyup: function($event) {
                                      return _vm.paymentSumChanged($event)
                                    }
                                  },
                                  model: {
                                    value: paymentItem.sum,
                                    callback: function($$v) {
                                      _vm.$set(paymentItem, "sum", _vm._n($$v))
                                    },
                                    expression: "paymentItem.sum"
                                  }
                                })
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  ],
                  1
                ),
                _vm._v(" "),
                !paymentItem.disabled
                  ? _c(
                      "b-col",
                      { attrs: { md: "3" } },
                      [
                        _c(
                          "b-row",
                          [
                            _c(
                              "b-col",
                              { staticClass: "pl-0", attrs: { md: "4" } },
                              [
                                !_vm.readonly
                                  ? _c(
                                      "b-button",
                                      {
                                        directives: [
                                          {
                                            name: "b-tooltip",
                                            rawName: "v-b-tooltip.hover",
                                            modifiers: { hover: true }
                                          }
                                        ],
                                        attrs: {
                                          size: "sm",
                                          title: "Назначить остаток суммы",
                                          variant: "success"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.setRemainingSum(index)
                                          }
                                        }
                                      },
                                      [
                                        _c("icon", {
                                          attrs: { name: "angle-double-left" }
                                        })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            ),
                            _vm._v(" "),
                            _c(
                              "b-col",
                              { staticClass: "pl-0", attrs: { md: "4" } },
                              [
                                !_vm.readonly
                                  ? _c(
                                      "b-button",
                                      {
                                        attrs: {
                                          size: "sm",
                                          variant: "danger"
                                        },
                                        on: {
                                          click: function($event) {
                                            return _vm.deletePayment(index)
                                          }
                                        }
                                      },
                                      [
                                        _c("icon", { attrs: { name: "times" } })
                                      ],
                                      1
                                    )
                                  : _vm._e()
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ],
              1
            )
          }),
          _vm._v(" "),
          !_vm.readonly
            ? _c(
                "b-button",
                {
                  staticClass: "w-100 mt-3",
                  attrs: { size: "md", variant: "success" },
                  on: {
                    click: function($event) {
                      return _vm.addPayment()
                    }
                  }
                },
                [_vm._v("Добавить тип оплаты")]
              )
            : _vm._e()
        ],
        2
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-34354db2", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-34354db2","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/ModalAddPayment.vue
// module id = null
// module chunks = 